import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseStep9.module.css';
import axios from 'axios'
import api from '../../../api';
import { isBrowser, isIOS } from 'react-device-detect';

const AdViseStep9 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const MAX_CAPTION_LENGTH = 2200;
    const captionText = stepProps[9]?.caption || '';
    const isOverLimit = captionText.length > MAX_CAPTION_LENGTH;

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const saveFiles = async () => {
        if(isOverLimit || isSaving)
            return;

        setIsSaving(true);

        try {
            const response = await api.post(
              `/advise/admin/update-caption`,
              {
                name: stepProps[8].fileName,
                caption: stepProps[9].caption,
                updated_device: isBrowser?'PC':(isIOS?'IOS':'ANDROID'),
                props: JSON.stringify(
                  stepProps.map((item, idx) => {
                    if (idx === 0) {
                        return {};
                    }
                    else if (idx === 3) {
                        return {...item, hotples: []};
                    }
                    else if (idx === 6) {
                        return {...item, blogImages: [], blogCursor: 0, officialImages:[], gifImages:{} };
                    }
                    else if (idx === 7) {
                        return {...item, originalImages: []};
                    }
                    else if (idx === 8) {
                      return {
                        ...item,
                        result: [],
                        video_preview: [],
                        oriFileName: stepProps[8].fileName,
                        file: null,
                        pages: []
                      };
                    }
                    return item;
                  })
                )
              }
            );

            setStepProps(prev => {
                const newProps = [...prev];
                newProps[10] = {
                    ...newProps[10],
                    adviseId: response.data.adviseId
                };
                return newProps;
            });
            setAdViseStep(10);
        } catch (error) {
          console.error('Error saveFiles:', error);
        } finally{
          setIsSaving(false);
        }
    }

    const cityNameMap = {
        '서울특별시': '서울',
        '부산광역시': '부산',
        '대구광역시': '대구',
        '인천광역시': '인천',
        '광주광역시': '광주',
        '대전광역시': '대전',
        '울산광역시': '울산',
        '세종특별자치시': '세종',
        '경기도': '경기',
        '강원특별자치도': '강원',
        '충청북도': '충북',
        '충청남도': '충남',
        '전북특별자치도': '전북',
        '전라남도': '전남',
        '경상북도': '경북',
        '경상남도': '경남',
        '제주특별자치도': '제주'
      };
      
    // 1) 키 이름들로 regex 생성
    const cityRegex = new RegExp(Object.keys(cityNameMap).join('|'), 'g');
    
    // 2) 주소 문자열에서 매칭되는 부분만 바꿔치기
    function shortenCity(address) {
        return (address || '').replace(cityRegex, match => cityNameMap[match]);
    }

    const requestCreateCaption = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post(
                'https://hotple.today/win-api/api/create-caption',
                {
                    place: stepProps[4].place,
                    promotional_text: stepProps[4].placeAnalysis.promotional_text,
                    instagramText: stepProps[3].hotple.media_caption,
                    key_features: stepProps[4].placeAnalysis.key_features,
                    positive_summary: stepProps[4].reviewAnalysis.positive_summary.map(item => item.summary),
                    description: stepProps[4].placeAnalysis.description
                }
            );

            const hooking = response.data.result.hooking || '';
            const desc = response.data.result.description || '';
            const feats = stepProps[4].placeAnalysis.key_features || [];
            const tags = response.data.result.hashtags || [];

            setStepProps(prev => {
                const newProps = [...prev];
                newProps[9] = {
                    result: response.data.result,
                    caption:
                    hooking
                    + `\n${desc}`
                    + `\n\n--------\n#${stepProps[3].hotple.name}`
                    + `\n📍${shortenCity(stepProps[3].hotple.address)}`
                    + "\n--------"
                    + (feats.length ? '\n' + feats.join('\n') : '')
                    + (tags.length ? '\n\n#' + tags.concat(["먹스타","먹팔","맞팔선팔"].sort(() => Math.random() - 0.5)).join(' #'): '')
                }
                return newProps;
            });
        } catch (error) {
          console.error('Error analysisPlace:', error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        if(stepProps[4].placeAnalysis){
            if(!stepProps[9].caption)
                requestCreateCaption();
        }
        else{
            if(!stepProps[9].caption){
                setStepProps(prev => {
                    const newProps = [...prev];
                    newProps[9] = {...newProps[9], caption: ""}
                    return newProps;
                });
            }
        }
    },[])

    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(8)}/>
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>STEP 9</b>
                    <div className={styles.stepdesc}>마지막이에요! 이런 본문은 어때요?</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} style={{height:`calc(100dvh - ${marginTop}px - 103px - 74px)`}}>
                <div className={styles.contentframe}>
                    {stepProps[9].caption!=null &&
                        <div className={styles.placeframe}>
                            <div className={styles.placetitle}>본문 편집</div>
                            <textarea
                                className={styles.placeresulttext}
                                value={captionText}
                                style={{ color: isOverLimit ? 'red' : 'inherit' }}
                                placeholder='피드 본문 입력'
                                onChange={e => {
                                    setStepProps(prev => {
                                        const newProps = [...prev];
                                        newProps[9] = {...newProps[9], caption: e.target.value}
                                        return newProps;
                                    });
                                    e.target.style.height = 'auto';
                                    e.target.style.height = e.target.scrollHeight + 'px';
                                }}
                                ref={el => {
                                    if (el) {
                                        el.style.height = 'auto';
                                        el.style.height = el.scrollHeight + 'px';
                                    }
                                    }}
                                rows={Math.max(captionText.split('\n').length, 4)}
                            />
                            <div
                                className={styles.charCounter}
                                style={{ color: isOverLimit ? 'red' : 'inherit' }}
                            >
                                글자 수: {captionText.length} / {MAX_CAPTION_LENGTH}
                                {isOverLimit && ' (글자 수 초과!)'}
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className={styles.nextbuttonframe}>
                <div className={styles.backbutton2} onClick={()=>requestCreateCaption()}>
                    <div className={styles.nextbuttontext2}>재생성</div>
                </div>
      			<div className={styles.nextbutton} onClick={()=>saveFiles()}>
        				<b className={isOverLimit || isSaving ? styles.nextbuttonDisabled : styles.nextbuttontext1}>저장하기 →</b>
      			</div>
    		</div>

            {isLoading &&
                <div className={styles.loadingFrame}>
                    <div className={styles.loader}/>
                    <div className={styles.loadingText}>
                        본문 생성 중...
                    </div>
                </div>
            }

            {isSaving &&
                <div className={styles.loadingFrame}>
                    <div className={styles.loader}/>
                    <div className={styles.loadingText}>
                        임시 저장 중...
                    </div>
                </div>
            }
        </div>
    );
}

export default AdViseStep9;